import { useTheme as useThemeWithoutDefaults } from "@material-ui/styles";
import { theme as defaultTheme } from "./theme";
export var useTheme = function () {
    var theme = useThemeWithoutDefaults() || defaultTheme;
    return theme;
};
